<template>
  <teleport to="body">
    <div v-if="show" class="modal is-active">
      <div class="modal-background" @click="$emit('close')"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
          <button
            class="delete"
            type="button"
            aria-label="close"
            @click="$emit('close')"
          ></button>
        </header>
        <section class="modal-card-body">
          <slot></slot>
        </section>
        <footer v-if="$slots.footer" class="modal-card-foot">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "BaseModal",
  emits: ["close"],
  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ""
    }
  },
  watch: {
    show(val) {
      document.body.style.overflow = val ? "hidden" : "";
    }
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  }
};
</script>

<style scoped>
.modal-card,
.modal-card-body {
  overflow: visible;
}
</style>
